import FormSnapshotter from "../form_snapshotter"

const FormSnapshot = {
  mounted() {
    // Child hooks normalize controls (e.g. the date picker's ISO separator)
    // during mount. Snapshot after them, before the next user-input task.
    queueMicrotask(() => {
      if (this.el.isConnected) this.updated()
    })
  },
  updated() {
    // Skip if data-snapshot-skip attribute is present
    if (this.el.hasAttribute("data-snapshot-skip")) {
      return
    }

    // Store snapshot if not already stored
    FormSnapshotter.store_if_needed(this.el)
  },

  destroyed() {
    // Clean up snapshot when element is removed
    FormSnapshotter.destroy(this.el)
  },
}

export { FormSnapshot }
